import { render } from "./HealthcareBox.vue?vue&type=template&id=638ed234&scoped=true"
import script from "./HealthcareBox.vue?vue&type=script&lang=js"
export * from "./HealthcareBox.vue?vue&type=script&lang=js"

import "./HealthcareBox.vue?vue&type=style&index=0&id=638ed234&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638ed234"]])

export default __exports__